import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
const __default__ = {
  name: "StaffsIndex",
  data: () => ({
    isLoading: {
      staffs: true
    },
    filterKeyword: "",
    staffs: [],
    // API からとってきたオリジナルデータ
    visibleStaffs: [] // 加工表示用
  }),
  head: {
    title: {
      inner: "職員一覧"
    },
    meta: []
  },
  created() {
    this.setData();
  },
  methods: {
    setData() {
      getData("staffs").then(data => {
        this.staffs = this.visibleStaffs = data.items;
      }).catch(error => {
        console.log(error);
      }).then(() => {
        this.isLoading.staffs = false;
      });
    },
    filterData: function (e) {
      e.preventDefault();
      let staffs = this.staffs;
      const keyword = this.filterKeyword;
      if (keyword) {
        staffs = staffs.filter(v => Object.keys(v).some(k => String(v[k]).indexOf(keyword) > -1));
      }
      this.visibleStaffs = staffs;
    }
  }
};
import { inject } from "vue";
import { getData } from "@/services/axios";

import { meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // @ts-check
    const me = inject(meKey);
    return {
      __sfc: true,
      me
    };
  }
});